export default __webpack_public_path__ + "google_play_badge.svg";